module["exports"] = [
  "ახალი",
  "ძველი",
  "ზემო",
  "ქვემო"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ge/address/city_prefix.js
// module id = 855
// module chunks = 0